import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * ReportesLayout — Contenedor para la sección "Reportes" del menú principal.
 * Por ahora solo renderiza el Outlet (cada página se maneja sola).
 */
export default function ReportesLayout() {
  return <Outlet />;
}
